import { createSlice } from '@reduxjs/toolkit';
import { CATEGORIES } from '../../helpers';

const initialState = Object.fromEntries(CATEGORIES.map((name) => [name, []]))

const transactionSlice = createSlice({
  name: 'transactions',
  initialState: initialState,
  reducers: {
    addTransaction: (state, action) => {
      state[action.payload.category].push({
        name: action.payload.name,
        amount: action.payload.amount,
        category: action.payload.category,
        id: action.payload.id,
      });
    },

    removeTransaction: (state, action) => {
      const index = state[action.payload.category].findIndex((t) => t.id === action.payload.id)

      state[action.payload.category].splice(index,1)
    },

    clearTransactions: (state) => {
      Object.keys(state).forEach((key) => {
        state[key] = [];
      });
    },
  },
});

export const { addTransaction, removeTransaction, clearTransactions } =
  transactionSlice.actions;
export default transactionSlice.reducer;
